import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1120SSchM2 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Schedule M‑2 Form 1120‑S Accounts Analysis | TaxZerone"
          description="Learn how to complete Schedule M‑2 (Form 1120‑S) to track your S corporation’s accumulated and other adjustments for accurate IRS compliance"
          keywords=""
          canonical="resources/business-tax/schedule-m-2/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Schedule M‑2</span>
          </span>{' '}
          (Form 1120-S)
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-m-2/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule M‑2 (Form 1120-S) at a glance
                  </Typography>

                  <Box
                    component="ul"
                    itemProp="articleBody"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of Schedule M-2 (Form 1120-S)
                        </strong>{' '}
                        and how S corporations use it to track changes in
                        shareholder equity accounts, including the Accumulated
                        Adjustments Account (AAA), Other Adjustments Account
                        (OAA), Previously Taxed Income (PTI), and Accumulated
                        Earnings and Profits (E&P).
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Schedule M-2 line by line,
                        </strong>{' '}
                        including beginning balances, income and loss
                        adjustments, other additions, reductions, shareholder
                        distributions, and year-end account balances.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand how Schedule M-2 connects with Schedule K,
                          Schedule M-1, and Schedule L
                        </strong>{' '}
                        and how these schedules work together to reconcile
                        taxable income, shareholder basis, financial records,
                        and equity changes.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Schedule M‑2 (
                      <Link
                        href="/business-tax/efile-irs-form-1120-s/"
                        sx={{ color: '#0202ff' }}
                      >
                        Form 1120‑S
                      </Link>
                      ) is used by S corporations to analyze changes in
                      shareholders’ equity accounts throughout the tax year. It
                      tracks movements in the Accumulated Adjustments Account
                      (AAA), Other Adjustments Account (OAA), and Previously
                      Taxed Income (PTI) to show how retained earnings evolve
                      from the beginning to the end of each tax period.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      This schedule works in harmony with Schedules L and M‑1 to
                      ensure the IRS understands how book income, adjustments,
                      and shareholder distributions affect the corporation’s
                      accumulated earnings. Properly completing Schedule M‑2
                      demonstrates transparency in how income flows and
                      distributions are handled under Subchapter S of the
                      Internal Revenue Code.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What Is Schedule M‑2 (Form 1120‑S)?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#purpose" sx={{ color: '#0202ff' }}>
                          Purpose of Schedule M‑2
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#key" sx={{ color: '#0202ff' }}>
                          Key Components of Schedule M‑2
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#step" sx={{ color: '#0202ff' }}>
                          Step-by-step Breakdown of Schedule M‑2
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#relation" sx={{ color: '#0202ff' }}>
                          Relationship Between Schedules L, M‑1, and M‑2
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must Complete Schedule M‑2?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mistakes to Avoid
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#best" sx={{ color: '#0202ff' }}>
                          Best Practices for Schedule M‑2 Compliance
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What Is Schedule M‑2 (Form 1120‑S)?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Unlike the C corporation version of{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 1120
                  </Link>
                  , which focuses on retained earnings, Schedule M‑2 for S
                  corporations specifically tracks accounts affecting
                  shareholder basis and previously taxed income. It reconciles:
                </Typography>

                <Typography variant="body1" component="div">
                  <ul style={{ marginBottom: 24 }}>
                    <li style={{ marginBottom: 16 }}>
                      The corporation’s beginning‑of‑year balances in key equity
                      accounts,
                    </li>
                    <li style={{ marginBottom: 16 }}>
                      Additions such as income or adjustments, and
                    </li>
                    <li style={{ marginBottom: 16 }}>
                      Reductions such as distributions or losses, to arrive at
                      the end‑of‑year balances that carry forward into the next
                      tax year.
                    </li>
                  </ul>
                </Typography>

                <Typography variant="body1" sx={{ mb: 4 }}>
                  The IRS uses Schedule M‑2 to verify that distributions were
                  properly reported, that shareholder basis was not overstated,
                  and that adjustments reconcile with income reported on
                  Schedule M‑1 and Schedule K.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="purpose"
                >
                  Purpose of Schedule M‑2
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule M‑2 ensures accurate tracking of shareholder
                  financial accounts by:
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    Showing how the Accumulated Adjustments Account (AAA)
                    changes as income and distributions occur.
                  </li>
                  <li>
                    Reflecting non‑taxable adjustments in the Other Adjustments
                    Account (OAA).
                  </li>
                  <li>
                    Preserving previously taxed income (PTI) carried over from
                    years when the corporation was a C corporation or before
                    1983 S status.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Accurate completion helps shareholders calculate their basis
                  limitations on losses and distributions, an essential element
                  for avoiding double taxation or disallowed deductions.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="key"
                >
                  Key Components of Schedule M‑2
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule M‑2 is subdivided into four columns, each
                  representing a separate equity account:
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    lineHeight: 1.5,
                  }}
                >
                  1. Column (a): Accumulated Adjustments Account (AAA)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Tracks the corporation’s accumulated income under S status
                  that has already been taxed to shareholders but not yet
                  distributed.
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>Opening balance:</span>{' '}
                    Previous year’s ending AAA balance
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Increases:</span> Ordinary
                    income, tax‑exempt income adjustments, and separately stated
                    items (e.g., dividends, royalties)
                  </li>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}>Decreases:</span>{' '}
                    Charitable contributions, nondeductible expenses, and
                    shareholder distributions{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  AAA represents the pool of distributable earnings to
                  shareholders that will not be taxed again when distributed.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    lineHeight: 1.5,
                  }}
                >
                  2. Column (b): Previously Taxed Income (PTI)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Reflects earnings taxed prior to conversion or S‑corporation
                  election (pre‑1983 income).
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>Additions:</span>{' '}
                    Adjustments carried from prior corporate tax years{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Reductions:</span>{' '}
                    Distributions of previously taxed income
                  </li>
                </Box>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  PTI is rarely used today but may apply to older corporations
                  with carryover accounts.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    lineHeight: 1.5,
                  }}
                >
                  3. Column (c): Accumulated Earnings and Profits (E&P)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Shows carryover earnings from the corporation’s prior
                  C‑corporation years.
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>Increases:</span> Adjusted
                    gross income retained before S status election
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Reductions:</span>{' '}
                    Distributions reducing C‑corp E&P before affecting AAA
                  </li>
                </Box>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  If the corporation once operated as a C‑Corporation, this
                  column ensures distributions are applied in the correct order
                  (E&P after AAA unless elected otherwise).
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    lineHeight: 1.5,
                  }}
                >
                  4. Column (d): Other Adjustments Account (OAA)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Captures items not included in AAA or E&P—primarily
                  non‑taxable income and related expenses.
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>Increases:</span>{' '}
                    Tax‑exempt interest, life insurance proceeds, or similar
                    non‑taxable earnings
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Decreases:</span> Expenses
                    related to tax‑exempt income or nondeductible losses
                  </li>
                </Box>

                <Typography variant="body1" sx={{ mb: 4 }}>
                  OAA ensures that shareholders’ equity accurately reflects
                  nondeductible and non‑taxable activities.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    scrollMarginTop: 83,
                  }}
                  id="step"
                >
                  Step‑by‑Step Breakdown of Schedule M‑2
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1120s-schm2-img.webp" />
                  <source srcSet="/assets/images/f1120s-schm2-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1120s-schm2-img.png"
                    loading="lazy"
                    alt="Form 1120-S Schedule M-2 showing the analysis of the Accumulated Adjustments Account and related equity accounts."
                    width={760}
                    height={241}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 1 – Balance at Beginning of Tax Year
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter the beginning balance for each applicable account. For
                    an S corporation's first tax year, the beginning of AAA
                    balance is <span style={{ fontWeight: 600 }}> zero</span>.
                  </li>
                  <li>
                    Enter a beginning balance for PTEP only if one exists, and
                    report AE&P if the corporation has accumulated earnings and
                    profits from prior C corporation years or certain tax-free
                    reorganizations.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 2 – Ordinary Income From Page 1, Line 22
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the ordinary business income reported on Form 1120-S,
                  Page 1, Line 22. This amount increases the Accumulated
                  Adjustments Account (AAA) but does not include tax-exempt
                  income or separately stated income items.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 3 – Other Additions
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter all other items that increase the applicable account.
                    For AAA, include separately stated taxable income items and
                    any excess depletion deduction, if applicable.
                  </li>
                  <li>
                    For the Other Adjustments Account (OAA), include tax-exempt
                    income and other required adjustments.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 4 – Loss From Page 1, Line 22
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the ordinary business loss reported on Form 1120-S, Page
                  1, Line 22. Report the amount as a reduction to the applicable
                  account.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 5 – Other Reductions
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter deductible losses and expenses, nondeductible expenses
                    (other than those related to tax-exempt income), shareholder
                    depletion deductions for oil and gas property, and any other
                    required reductions.
                  </li>
                  <li>
                    If the corporation has a net negative adjustment, apply the
                    IRS ordering rules when reducing the AAA.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 6 – Combine Lines 1 Through 5
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add Lines 1 through 3 and subtract Lines 4 and 5 to determine
                  the balance of each account before shareholder distributions.
                  Enter the result for each applicable column.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 7 – Distributions
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter property or cash distributions made during the tax year.
                  Unless the corporation makes a valid election, distributions
                  generally reduce the accounts in the following order: AAA,
                  PTEP, AE&P, OAA, and then any remaining shareholders' equity
                  accounts.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 19, sm: 18, xs: 17 },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  Line 8 – Balance at End of Tax Year
                </Typography>
                <Typography variant="body1" sx={{ mb: 3.5 }}>
                  Subtract Line 7 from Line 6 to determine the ending balance of
                  each account. The ending balance is carried forward to the
                  next tax year. Under certain circumstances, the AAA may have a
                  negative balance at year-end.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="relation"
                >
                  Relationship Between Schedules L, M‑1, and M‑2
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>
                    Schedule L provides the book balance‑sheet data at the
                    beginning and end of the year.
                  </li>
                  <li>
                    Schedule M‑1 reconciles book income with taxable income.
                  </li>
                  <li>
                    Schedule M‑2 shows how those results affect shareholder
                    accounts (AAA, OAA, PTI, E&P).{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Together, these schedules demonstrate complete consistency
                  between a corporation’s financial accounting, tax
                  reconciliation, and shareholder‑level equity activity.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must Complete Schedule M‑2?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Every S corporation that is required to file Schedule L and
                  M‑1 must also complete Schedule M‑2.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  You can skip Schedules L, M‑1, and M‑2 only if both of the
                  following are true:
                </Typography>
                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                  <li>Total receipts are under $250,000, and </li>
                  <li>Total year‑end assets are under $250,000. </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  However, most S corporations must file it to ensure
                  transparency between taxable income and shareholder basis
                  adjustments.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Filing Deadlines
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule M‑2 is filed with{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120‑S
                  </Link>{' '}
                  by the usual S corporation deadline.
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Deadline (Tax Year 2025)
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporation </TableCell>
                          <TableCell>Form1120‑S </TableCell>
                          <TableCell>March 16, 2026 * </TableCell>
                          <TableCell>
                            {' '}
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 7004
                            </Link>{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography variant="body1" sx={{ mb: 3, fontStyle: 'italic' }}>
                  If March 15 falls on a weekend or legal holiday, the deadline
                  moves to the next business day. Filing Form 7004 gives an
                  automatic six‑month extension (to September 15, 2026).
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Errors to Avoid
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Mistake
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Impact
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Correction Tip
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Beginning balance not matching prior‑year
                            ending{' '}
                          </TableCell>
                          <TableCell>Causes audit red flags </TableCell>
                          <TableCell>
                            Recheck closing balances from last year’s
                            return.{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Misallocating distributions between AAA and E&P{' '}
                          </TableCell>
                          <TableCell>
                            Leads to double taxation or misreported basis{' '}
                          </TableCell>
                          <TableCell>
                            Apply IRS ordering rules carefully.{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Ignoring non‑taxable adjustments in OAA
                          </TableCell>
                          <TableCell>
                            Skewed shareholder basis and equity reporting{' '}
                          </TableCell>
                          <TableCell>
                            Record all tax‑exempt and nondeductible items.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Failing to align with Schedule K and M‑1
                          </TableCell>
                          <TableCell>
                            Creates inconsistencies and return rejections
                          </TableCell>
                          <TableCell>
                            Reconcile all schedules before submission.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="best"
                >
                  Best Practices for Schedule M‑2 Compliance
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Maintain detailed year‑end reconciliations between tax and
                    book earnings.
                  </li>
                  <li>
                    Track shareholder distributions separately for AAA and E&P.
                  </li>
                  <li>
                    Record and substantiate all adjustments affecting
                    shareholder basis.
                  </li>
                  <li>
                    Use professional e‑filing software like TaxZerone to
                    auto‑populate Schedule M‑2 from your Schedule K and M‑1 data
                    to minimize calculation errors.{' '}
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What is reported on Schedule M‑2 (Form 1120‑S)?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It reports yearly changes in equity accounts like AAA, OAA,
                  previously taxed income, and accumulated earnings and profits.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Why is Schedule M‑2 important for shareholders?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It directly impacts shareholder basis and determines how much
                  of distributed earnings are taxable.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. Can an S corporation have negative AAA or OAA balances?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, negative balances can occur from operating losses or
                  excess distributions. Document them for clarity.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. How does Schedule M‑2 connect to Schedule L?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Ending balances on Schedule M‑2 should tie to shareholder
                  equity figures on the Schedule L balance sheet.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              File Your Form 1120‑S Including Schedule M‑2 with TaxZerone
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure your S corporation’s shareholder accounts are accurate and
              IRS‑compliant.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120schm2`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1120SSchM2;
